import React, { memo } from 'react';

const KeyIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={20}
      height={20}
      viewBox='0 0 20 20'
      fill='none'
      {...props}
    >
      <path
        d='M15.5467 16.335V3.77849L10.0019 0.577148L4.45703 3.77849V16.335L10.0019 19.5363L15.5467 16.335Z'
        fill='#22C55E'
      />
      <path
        d='M10 19.5363L15.5449 16.335V3.77849L10 0.577148V19.5363Z'
        fill='#15803D'
      />
      <path
        d='M13.6428 14.6043V5.396L10.0011 3.29346L6.35938 5.396V14.6043L10.0011 16.7068L13.6428 14.6043Z'
        fill='#86EFAC'
      />
      <path
        d='M10 16.7068L13.6417 14.6043V5.396L10 3.29346V16.7068Z'
        fill='#22C55E'
      />
      <path
        d='M13.6445 5.39445L15.5477 3.77686V16.3333L13.6445 14.6027V5.39445Z'
        fill='#86EFAC'
      />
      <path
        d='M6.36016 5.39445L4.45703 3.77686V16.3333L6.36016 14.6027V5.39445Z'
        fill='#DCFCE7'
      />
    </svg>
  );
};

export default memo(KeyIcon);
